<template>
  <div class="mt-3 ml-2">
    <img
      src="https://s3.amazonaws.com/lumapix/memento_static/logos/mementoYearbookLogoSmall.png"
      width="200"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
